<div
  class="simple-search-container"
  matTooltip="{{ tooltip }}"
  [matTooltipPosition]="tooltipPosition"
  matTooltipShowDelay="{{ tooltipDelay }}"
>
  <div class="simple-search-bar">
    <mat-icon class="search-icon">search</mat-icon>
    <input
      type="text"
      [formControl]="searchControl"
      class="simple-search-input"
      [placeholder]="placeholder"
    />
  </div>
</div>
